import _ from 'lodash';

export const getPermissions = object => _.get(object, '_meta.permissions', []);

export const getGlobalPermissions = (object, type) =>
  _.get(object, `globalPermissions.${type}`, []);

export const can = (object, permissions) =>
  !!_.intersection(getPermissions(object), permissions).length;

export const canGlobal = (object, type, permissions) =>
  !!_.intersection(getGlobalPermissions(object, type), permissions).length;



// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/utils/permissions.js